// Offline status for E-Bibliotheek / Dharmaleer items.
// - useOfflineColumn(): a list column with a clickable badge (needs "<module>.offline").
// - OfflineField: checkbox for the create/edit form.
import React, { useCallback, useContext, useState } from "react";
import { AuthContext } from "../../context/Authcontext";
import "../../pages/screens/appgroups/AppGroups.css";

export const useOfflineColumn = (permission, saveFn) => {
  const { can } = useContext(AuthContext);
  const allowed = can(permission);
  const [overrides, setOverrides] = useState({});

  const toggle = useCallback(async (item) => {
    const current = overrides[item._id] ?? Boolean(item.offlineAllowed);
    const next = !current;
    const label = next ? "offline beschikbaar maken" : "terugzetten naar alleen online";
    if (!window.confirm(`"${item.title}" ${label}?`)) return;
    try {
      await saveFn(item._id, next);
      setOverrides((prev) => ({ ...prev, [item._id]: next }));
    } catch (err) {
      alert(err.message || "Wijzigen mislukt");
    }
  }, [overrides, saveFn]);

  return {
    key: "offlineAllowed",
    label: "Beschikbaarheid",
    render: (_value, item) => {
      const on = overrides[item._id] ?? Boolean(item.offlineAllowed);
      const text = on ? "Offline toegestaan" : "Alleen online";
      if (!allowed) return <span className={`offline-badge ${on ? "yes" : "no"}`}>{text}</span>;
      return (
        <button
          type="button"
          className={`offline-badge ${on ? "yes" : "no"}`}
          title="Klik om te wijzigen"
          onClick={(e) => { e.stopPropagation(); toggle(item); }}
        >
          {text}
        </button>
      );
    },
  };
};

export const OfflineField = ({ permission, checked, onChange }) => {
  const { can } = useContext(AuthContext);
  const allowed = can(permission);
  return (
    <div className="form-group">
      <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: allowed ? "pointer" : "not-allowed" }}>
        <input
          type="checkbox"
          checked={Boolean(checked)}
          disabled={!allowed}
          onChange={(e) => onChange(e.target.checked)}
          style={{ width: 18, height: 18 }}
        />
        Offline beschikbaar in de app
      </label>
      <small style={{ color: "#6b4d39" }}>
        Standaard: alleen online. Indien aangevinkt mogen gebruikers dit opslaan in hun Offline bibliotheek.
        {!allowed && " U heeft geen recht om dit te wijzigen."}
      </small>
    </div>
  );
};
